import '@tabler/core/dist/js/tabler.min.js';
import icon from '@brand/assets/icon.png'
import {createApp} from 'vue'
import {createPinia} from 'pinia'
import {version} from '../package.json'
import App from './App.vue'
import router from './router'
import * as Sentry from "@sentry/vue";
import {permissionService} from "@/services/PermissionService";

// Load cached permissions early (before auth)
permissionService.loadFromCache();
//import posthog from "@/services/posthog.js";

const app = createApp(App)
app.config.globalProperties.__DICT__ = __DICT__

Sentry.init({
    app,
    dsn: "https://cc53d977547fa0e801e32ddda39b24b7@o314448.ingest.us.sentry.io/4508959433293824",
    integrations: [
        Sentry.replayIntegration(),

    ],
    //tracePropagationTargets: [/^https:\/\/api.snowfuze.com/],
    tracesSampleRate: 0.5,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    release: version,
    ignoreErrors: [
        'Authentication failed - please log in again',
        'Session expired - please log in again',
        'Temporary authentication issue. Please try again.',
        // AbortErrors are expected when users navigate away
        'AbortError',
        'The operation was aborted',
        'The fetching process for the media resource was aborted',
        'The user aborted a request',
        // Network errors are user connectivity issues
        'Load failed',
        'Failed to fetch',
        'NetworkError',
        'Network request failed',
        // Safari-specific pattern matching error (browser bug)
        'The string did not match the expected pattern',
        // Outlook Safe Links / Defender scanner opening emailed links (SNOWFUZE-6J)
        /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/
    ],
    beforeSend(event, hint) {
        try {
            const original = hint && hint.originalException

            // api.js stamps the id it sent as x-correlation-id onto the error.
            // Lifting it to a tag is what makes a Sentry event searchable
            // against apiLogs, errorLog and the Slack alert for the same call.
            if (original && original.correlationId) {
                event.tags = {...(event.tags || {}), correlation_id: original.correlationId}
            }
            const message = (original && original.message) || (event && event.exception && event.exception.values && event.exception.values[0] && event.exception.values[0].value) || ''
            const msg = String(message).toLowerCase()
            const errorType = (original && original.name) || ''

            // Filter out AbortErrors (user navigation)
            if (errorType === 'AbortError' || msg.includes('abort')) {
                return null
            }

            // Filter out network errors (user connectivity)
            if (
                errorType === 'TypeError' && msg.includes('load failed') ||
                msg.includes('failed to fetch') ||
                msg.includes('network') ||
                msg.includes('unable to fetch data')
            ) {
                return null
            }

            // Ignore expected auth-flow errors that can be thrown during logout/refresh handling
            if (
                msg.includes('authentication failed - please log in again') ||
                msg.includes('session expired - please log in again') ||
                msg.includes('temporary authentication issue')
            ) {
                return null
            }
        } catch (_) {
            // no-op
        }
        return event
    }
});

// Prevent noisy unhandled promise rejections for expected auth errors
if (typeof window !== 'undefined') {
    window.addEventListener('unhandledrejection', (event) => {
        try {
            const reason = event && event.reason
            const message = (reason && reason.message) ? String(reason.message) : String(reason || '')
            const msg = message.toLowerCase()
            const isExpectedAuthError = (
                msg.includes('authentication failed - please log in again') ||
                msg.includes('session expired - please log in again') ||
                msg.includes('temporary authentication issue')
            )
            if (isExpectedAuthError) {
                event.preventDefault()
                // Optionally log for diagnostics without error noise
                console.warn('[Auth] Suppressed expected auth rejection:', message)
            }
        } catch (_) {
            // ignore
        }
    })
}

//app.use(posthog);
app.use(createPinia())
app.use(router)

app.mount('#app')
